import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';

const CollectionHeroImage = ({ heroImage, onClick, link }) => {
  const isMobile = useMedia('(max-width: 767px)');

  if (!heroImage?.length) return null;

  const [image, mobileImage] = heroImage;
  const imgUrl = isMobile ? mobileImage?.src || image?.src : image?.src;
  const img = (
    <img
      role="presentation"
      style={onClick ? { cursor: 'pointer' } : null}
      src={imgUrl}
      alt={onClick ? 'Collection Hero Content Toggle' : 'Collection Hero'}
      onClick={onClick}
    />
  );
  return (
    <>
      <link rel="preload" href={imgUrl} as="image" />
      {link ? <a href={link} title="Collection Hero link">{img}</a> : img}
    </>
  );
};

CollectionHeroImage.propTypes = {
  heroImage: PropTypes.array,
  onClick: PropTypes.func,
  link: PropTypes.string
};

CollectionHeroImage.defaultProps = {
  heroImage: null,
  onClick: null,
  link: null
};

export { CollectionHeroImage };
